
const messages = {
    en: {
       delivery: {
          productCategory: {
            name: 'ProductCategory',
            title: 'ProductCategory management',
            subtitle: 'View, search, create, edit and delete ProductCategory',
            creating: 'Creating ProductCategory',
            editing: 'Editing ProductCategory',
            deleting: 'Deleting ProductCategory',
            showing: 'Showing ProductCategory',
            menu: 'ProductCategory',
            labels: {
                name: 'Name',
                printName: 'Print Name',
                dozen: 'Dozens',
                backgroundColor: 'Background Color',
                borderColor: 'Border Color',
                fontColor: 'Font color',
                iconColor: 'Icon color',
                icon: "Icon",
                surcharge: 'Surcharge',
                minimumDeliveryQuantity: 'Minimum delivery quantity',
                minimumTakeAwayQuantity: 'Minimum take away quantity',
                immediateDelivery: 'Enable immediate delivery',
                drink: 'Drink',
                active: 'Activo',
            },

          }
       }
    },
    es: {
       delivery: {
          productCategory: {
            name: 'ProductCategory',
            title: 'Administración de ProductCategory',
            subtitle: 'Ver, buscar, crear, editar, y borrar ProductCategory',
            creating: 'Creando ProductCategory',
            editing: 'Modificando ProductCategory',
            deleting: 'Eliminando ProductCategory',
            showing: 'Detalles de ProductCategory',
            menu: 'ProductCategory',
            labels: {
                name: 'Nombre',
                printName: 'Nombre impreso',
                dozen: 'Docenas',
                backgroundColor: 'Color de fondo',
                borderColor: 'Color de borde',
                fontColor: 'Color de fuentes',
                iconColor: 'Color de icono',
                icon: "Icono",
                surcharge: 'Recargo',
                minimumDeliveryQuantity: 'Minima cantidad Delivery',
                minimumTakeAwayQuantity: 'Minima cantidad Take away',
                immediateDelivery: 'Habilitar Entrega Inmediata',
                drink: 'Bebida',
                active: 'Activo',
            },

          }
       }
    },
    pt: {
       delivery: {
          productCategory: {
            name: 'ProductCategory',
            title: 'Administração de ProductCategory',
            subtitle: 'Ver, buscar, criar, editar e usar ProductCategory',
            creating: 'Criando ProductCategory',
            editing: 'Edição ProductCategory',
            deleting: 'Apagando ProductCategory',
            showing: 'Detalhes do ProductCategory',
            menu: 'ProductCategory',
            labels: {
                name: 'Nome',
                printName: 'Nome impreso',
                backgroundColor: 'Color de fondo',
                borderColor: 'Color de borde',
                fontColor: 'Color de fuentes',
                iconColor: 'Icon color',
                icon: "Icon",
                surcharge: 'Recargo',
                minimumDeliveryQuantity: 'Minima cantidad Delivery',
                minimumTakeAwayQuantity: 'Minima cantidad Take away',
                immediateDelivery: 'Habilitar Entrega Inmediata',
                drink: 'Bebida',
                active: 'Activo',
            },

          }
       }
    }
}

export default messages
